export const hkHandlersStr =
// to apply, copy the text between the "==========" lines, run in browser dev-tools/console, copy that JSON string, and send it to the HK backend (at: http://localhost:5140/docs#/default/add_handlers_handler_post)
// ==========
JSON.stringify({
	"@context": {
		ex: "http://example.com/schema/v0/",
	},
	handlers: [
		{
			event_type: "ex:create_node",
			target_role: "topic",
			target_range: "ex:node",
			code_text: function handler(event, existing) {
				//return {...event.data, "@id": event.data.topic, topic: undefined};
				// use Object.assign instead of spread-operator, since typescript is currently transpiling it to use "_extends" (which doesn't exist in the hk-backend's js-context)
				return Object.assign({}, event.data, {"@id": event.data.topic}, {topic: undefined}); // eslint-disable-line
			}.toString(),
		},
		{
			event_type: "ex:update_node",
			target_role: "topic",
			target_range: "ex:node",
			code_text: function handler(event, existing) {
				delete event.data.topic;
				return Object.assign(existing.topic || {}, event.data);
			}.toString(),
		},
		{
			event_type: "ex:create_link",
			target_role: "topic",
			target_range: "ex:link",
			code_text: function handler(event, existing) {
				//return {...event.data, "@id": event.data.topic, topic: undefined};
				// use Object.assign instead of spread-operator, since typescript is currently transpiling it to use "_extends" (which doesn't exist in the hk-backend's js-context)
				return Object.assign({}, event.data, {"@id": event.data.topic}, {topic: undefined}); // eslint-disable-line
			}.toString(),
		},
		{
			event_type: "ex:update_link",
			target_role: "topic",
			target_range: "ex:link",
			code_text: function handler(event, existing) {
				delete event.data.topic;
				return Object.assign(existing.topic || {}, event.data);
			}.toString(),
		},
	],
}, null, 2);
// ==========
export const hkHandlers = JSON.parse(hkHandlersStr) as {
	handlers: Array<{
		event_type: string;
		target_role: string;
		target_range: string;
		code_text: string;
	}>
};
export const hkHandlers_active = hkHandlers.handlers.map(handlerJSON=>{
	const handler = eval(`(${handlerJSON.code_text})`) as (event: any, existing: any)=>any;
	return {...handlerJSON, handler};
});